import { QueryClient, QueryCache } from "@tanstack/react-query"
import { showSnackbarGlobal } from "../context/SnackbarProvider"

const getApiErrorMessage = (error) => {
  const apiError = error?.response?.data?.error
  return (
    apiError?.message ||
    (typeof apiError === "string" ? apiError : null) ||
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong. Please try again."
  )
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // Queries that only decorate a screen (badge counts and the like) opt out
    // with `meta: { silentError: true }`, so one outage does not stack a toast
    // per companion request on top of the one the main query already raised.
    onError: (error, query) => {
      if (query?.meta?.silentError) return
      const message = getApiErrorMessage(error)
      if (message) {
        showSnackbarGlobal(message, "error")
      }
    },
  }),

  defaultOptions: {
    queries: {
      retry: false, // Prevents multiple retries during background polling failure
      staleTime: 30000,
    },
  },
})
